"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearLocalStorage = exports.getLocalStorageKey = exports.setLocalStorageKey = exports.setCookie = exports.getCookie = exports.isServerSideRendering = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
const isServerSideRendering = () => typeof window === 'undefined';
exports.isServerSideRendering = isServerSideRendering;
const getCookie = cookie => {
  if ((0, exports.isServerSideRendering)()) return '';
  const cookieString = document.cookie.split(';').filter(item => item.includes(cookie));
  const regex = /=(.+)/g;
  if (cookieString.length) {
    // @ts-ignore
    return regex.exec(cookieString[0])[1];
  }
  return '';
};
exports.getCookie = getCookie;
const setCookie = function (name, value) {
  let maxAge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2592000;
  if (!(0, exports.isServerSideRendering)()) {
    const cookie = [`${name}=${encodeURIComponent(value)}`, 'path=/', `max-age=${maxAge}`];
    // If we don't have the domain, don't push a domain value
    if (process.env.REACT_APP_BASE_DOMAIN) {
      cookie.push(`domain=${process.env.REACT_APP_BASE_DOMAIN}`);
    }
    document.cookie = cookie.join(';');
  }
};
exports.setCookie = setCookie;
const setLocalStorageKey = function (key, value) {
  let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2592000;
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl
  };
  window.localStorage.setItem(key, JSON.stringify(item));
};
exports.setLocalStorageKey = setLocalStorageKey;
const getLocalStorageKey = key => {
  try {
    const itemStr = window.localStorage.getItem(key);
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage and return null
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    return null;
  }
};
exports.getLocalStorageKey = getLocalStorageKey;
const clearLocalStorage = () => window.localStorage.clear();
exports.clearLocalStorage = clearLocalStorage;